// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"b6ac7167","922":"744f2ff1"}[chunkId] + ".chunk.js";
};